import React, { Component } from 'react';
import Success from '../components/css/dark/img/success.svg';
import { BrowserRouter as Router, Route, NavLink, Link } from 'react-router-dom';
import $ from 'jquery';

class PasswordChanged extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        document.title = 'Change Password Page';
    }
    render() {
        let logoUrl = '';
        if (window.location.host.toLowerCase() == "reporting.patientrxdiscount.com") {
            logoUrl = window.location.origin + '/Patient-Rx-Discount.svg';
        } else if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "glichealth.com" && window.location.host.toLowerCase() != "tempfilter-dev.glichealth.com") {
            logoUrl = window.location.origin + '/GlicHealth_logo.png';
        } else if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
            logoUrl = window.location.origin + '/Rxhacker_logo_new.png';
        } else if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "honestdiscounts.com") {
            logoUrl = '/hdrx-logo.svg';
        } else {
            logoUrl = window.location.origin + '/GlicHealth_logo.png';//window.location.origin+'/hdrx-logo.svg';
        }
        return (
            <div className="reset-password password-changed">
                <div className="main">
                    <div className="adjust-content">

                        <form name="form">
                            <img className="honest-logo" src={window.location.host.toLowerCase() == "reporting.patientrxdiscount.com" ? window.location.origin + '/Patient-Rx-Discount.svg' : logoUrl} crossorigin="anonymous" alt="logo" />
                            <img className="success" src={Success} alt="Success" />                            
                            <h3>Your new password has been sent to your email address. Please be sure to check your spam</h3>
                            <NavLink to="/login" activeClassName="active" className="signInButton backToSignIn btn">Go to Sign In</NavLink>
                        </form>

                    </div>
                </div>
            </div>
        )
    }
}
export default PasswordChanged;